import { ErrorBoundary } from "@sentry/react";
import { contentMain } from "plos/src/layouts";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

const ScoutErrorFallback = () => {
  const { t } = useTranslation("scout");
  return (
    <div className={contentMain}>
      <h4>{t("errorShowingContent", "Problem showing scout content.")}</h4>
    </div>
  );
};

const ScoutErrorBoundary = ({ children }: { children?: ReactNode }) => (
  <ErrorBoundary fallback={<ScoutErrorFallback />}>{children}</ErrorBoundary>
);

export default ScoutErrorBoundary;
